type Props = {
  variant: 'origin' | 'dest';
  className?: string;
};

/**
 * Start-/målmarkör. Från = ifylld startpunkt (GPS-look), Till = kartnål.
 * Färg sätts via CSS (currentColor) i .route-marker--*.
 */
export function RouteMarker({ variant, className }: Props) {
  const cls = `route-marker route-marker--${variant}${className ? ` ${className}` : ''}`;

  if (variant === 'origin') {
    return (
      <svg className={cls} viewBox="0 0 16 16" width="15" height="15" aria-hidden focusable="false">
        <circle cx="8" cy="8" r="7" fill="currentColor" />
        <circle cx="8" cy="8" r="2.7" fill="#fff" />
      </svg>
    );
  }

  return (
    <svg className={cls} viewBox="0 0 24 24" width="16" height="16" aria-hidden focusable="false">
      <path
        fill="currentColor"
        d="M12 2c-3.87 0-7 3.13-7 7 0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5A2.5 2.5 0 1 1 12 6.5a2.5 2.5 0 0 1 0 5z"
      />
    </svg>
  );
}
